import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

export interface SqlAttemptInfo {
  attempt: number;
  sql: string;
  error?: string;
}

export interface SqlChartDataset {
  label: string;
  data: number[];
}

export interface SqlVisualization {
  type: 'bar' | 'line' | 'pie' | 'doughnut' | 'none' | string;
  title?: string;
  labels: string[];
  datasets: SqlChartDataset[];
}

export interface SqlChatResponse {
  response_text: string;
  ai_summary?: string;
  sql?: string;
  columns: string[];
  rows: any[][];
  row_count: number;
  visualization?: SqlVisualization | null;
  attempts: SqlAttemptInfo[];
  schema_tables_used: string[];
  error?: string;
  success: boolean;
}

export interface SchemaTableInfo {
  name: string;
  columns: { name: string; type: string; nullable?: boolean }[];
  foreign_keys: { column: string; references: string }[];
}

export interface SchemaResponse {
  source: string;
  database: string;
  tables: SchemaTableInfo[];
  table_count: number;
}

@Injectable({ providedIn: 'root' })
export class SqlChatbotService {
  private readonly BASE = `${environment.chatbotApiUrl}sql-chat`;

  constructor(private http: HttpClient) {}

  sendMessage(sessionId: string, message: string, history?: any[]): Observable<SqlChatResponse> {
    return this.http.post<SqlChatResponse>(this.BASE, {
      session_id: sessionId,
      message,
      context: history ? { history } : undefined,
    });
  }

  resetSession(sessionId: string): Observable<any> {
    return this.http.post(`${this.BASE}/reset?session_id=${sessionId}`, {});
  }

  getSchema(refresh = false): Observable<SchemaResponse> {
    return this.http.get<SchemaResponse>(`${this.BASE}/schema?refresh=${refresh}`);
  }

  getDbStatus(): Observable<DbStatusResponse> {
    return this.http.get<DbStatusResponse>(`${this.BASE}/db-status`);
  }
}

export interface DbStatusResponse {
  connected: boolean;
  source: string;
  server?: string;
  database?: string;
  error?: string;
}
